import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError, map, Observable } from 'rxjs';
import { GetConsentInfo } from '../state/public.state';

export const consentTokenGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
): Observable<boolean> | Promise<boolean> => {
  const router = inject(Router);
  const store = inject(Store);

  if (next.queryParams['token']) {
    return store.dispatch(new GetConsentInfo(next.queryParams['token'])).pipe(
      map(() => true),
      catchError(() => {
        return router.navigate(['/error']);
      }),
    );
  }

  return router.navigate(['/error']);
};
